export const environmentTransactions = {
  API_KEY: 'PBxc0p3bsb4E2gqSzx29oDwaBgQPFM377ASwIBic',
  CLIENT_ID: '5siq6cdq44n29jformotc6jpg8',
  CLIENT_SECRET: 'u896ge6i94t2fnohs0k0hnstppg631c0dua1bmhut53pqj516fb',
  PRODUCTION: false,
  ENTITY_ID: '31',
  ENDPOINT_TRAMITES:'https://api.soyyo.mobi/snb-transaction/transaction/v2.1/transactions/',
}